import { Directive, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[preventCutCopyPaste]'
})
export class PreventCutCopyPasteDirective {
    constructor() { }

    @Input("") copyAllowed:boolean;

    @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
        if(!this.copyAllowed)
        e.preventDefault();
    }

    @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
        if(!this.copyAllowed)
        e.preventDefault();
    }

    @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
        if(!this.copyAllowed)
        e.preventDefault();
    }
}